import React, { useState } from 'react';
import {
  Box,
  ErrorMessage,
  FlatTextInput,
  Inscription,
  LinkButton,
  OverflowText,
  RawButton,
  ResetIcon,
  Text,
} from '@common-fe/common-fe';

import theme from '@/styles/theme';

export interface PlanCodeFieldProps {
  planCode?: string;
  defaultPlanCode?: string;
  onChange?: (value: string) => void;
  onReset?: () => void;
  showEditAction?: boolean;
  isViewMode?: boolean;
  showError?: boolean;
  errorText?: string;
  testId?: string;
}

const PlanCodeField: React.FC<PlanCodeFieldProps> = ({
  planCode,
  defaultPlanCode,
  onChange,
  onReset,
  showEditAction,
  isViewMode,
  showError,
  errorText,
  testId = 'plan-code-field',
}) => {
  const [isEditMode, setEditMode] = useState(false);

  const displayValue = isViewMode && !showEditAction ? defaultPlanCode : planCode || defaultPlanCode || '';

  return (
    <Box>
      <Box direction="row" align="center">
        <Text color="textBody" margin={{ right: 'spacing4' }} style={{ whiteSpace: 'nowrap' }}>
          Plan code:
        </Text>
        <OverflowText textStyle={{ fontWeight: 'bold' }} title={displayValue} />
        {!isEditMode && showEditAction && (
          <LinkButton
            testId={`${testId}_edit-button`}
            linkInlineMode
            style={{ marginLeft: theme.spacings.spacing4 }}
            onClick={() => setEditMode(true)}
          >
            <Inscription lineHeight="26px">Edit</Inscription>
          </LinkButton>
        )}
      </Box>
      {!isEditMode && showError && errorText && <ErrorMessage errorText={errorText} />}
      {isEditMode && (
        <Box direction="row" margin={{ top: 'spacing12' }}>
          <Box width="190px" margin={{ right: 'spacing12' }}>
            <FlatTextInput
              onChange={(value) => onChange?.(value)}
              value={planCode || ''}
              testId={`${testId}_input`}
              placeholder="Enter Plan code"
              errorText={showError ? errorText : undefined}
            />
          </Box>
          <Box style={{ position: 'relative' }}>
            <RawButton
              data-testId={`${testId}_reset-button`}
              onClick={() => onReset?.()}
              style={{ position: 'absolute', top: theme.spacings.spacing12, cursor: 'pointer' }}
            >
              <ResetIcon size="16px" color="iconPrimary" />
            </RawButton>
          </Box>
        </Box>
      )}
    </Box>
  );
};

export default PlanCodeField;
